import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  serverUrls = (environment as any).serverUrls;

  authTokens = (environment as any).authTokens;

}
